import VueCookies from "vue-cookies";
import moment from "moment/moment";

export default {
    methods: {
        isMobileMixin() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true;
            } else {
                return false;
            }
        },
        NormalizeRecursive(value) {
            const result = this.NormalizeRecursiveChild(value, null, "attributes");
            return result;
        },
        NormalizeRecursiveChild(value, parent, keyToFlatten) {
            let result = value;
            if (typeof value === "object" && !Array.isArray(value) && value !== null) {
                let flattened = value;
                if (value[keyToFlatten] !== undefined) {
                    const valueToFlatten = value[keyToFlatten];
                    Object.assign(value, valueToFlatten);
                    flattened = value;
                }
                result = {};
                Object.keys(flattened).map(key => {
                    if (key !== keyToFlatten) {
                        result[key] = this.NormalizeRecursiveChild(flattened[key], value, keyToFlatten);
                    }
                });
            } else if (Array.isArray(value)) {
                result = [];
                value.map((value2, key) => {
                    result[key] = this.NormalizeRecursiveChild(value2, value, keyToFlatten);
                });
            }
            return result;
        },
        DefaultSISHeaders() {
            const accessToken = VueCookies.get("sisAccessToken");
            const tenantId = VueCookies.get("sisTenantId");

            let defaultHeaders = {
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
                "Content-Type": "application/json",
            };

            if (accessToken) {
                defaultHeaders["Authorization"] = "Bearer " + accessToken;
            }

            if (tenantId) {
                defaultHeaders["X-Tenant"] = tenantId;
            }
            return defaultHeaders;
        },
        isSignedIntToSis(){
            //Check if the cookie sisAccessToken is not undefined and not null
            return VueCookies.get("sisAccessToken") !== undefined && VueCookies.get("sisAccessToken") !== null;
        },
        DefaultSISHeadersAndBaseUrl() {
            const result = {
                baseURL: window.location.hostname.includes("sis-central")
                    ? process.env.VUE_APP_SIS_CENTRAL_API_URL
                    : process.env.VUE_APP_SIS_TENANT_API_URL,
                headers: {
                    ...this.DefaultSISHeaders(),
                },
            };
            return result;
        },
        DefaultLMSHeaders() {
            const lmsAccessToken = VueCookies.get("lmsAccessToken");
            const lmsTenantId = VueCookies.get("lmsTenantId");

            let defaultHeaders = {
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
                "Content-Type": "application/json",
            };
            if (lmsAccessToken) {
                defaultHeaders["X-Is-LMS-Request"] = 1;
                defaultHeaders["Authorization"] = "Bearer " + lmsAccessToken;
            }

            if (lmsTenantId) {
                defaultHeaders["X-Tenant"] = lmsTenantId;
            }

            return defaultHeaders;
        },
        DefaultLMSHeadersAndBaseUrl() {
            const result = {
                baseURL: process.env.VUE_APP_API_V4_URL,
                headers: {
                    ...this.DefaultLMSHeaders(),
                },
            };
            return result;
        },
        collectionCheckValueMatchesField(collection, value, field) {
            const check = collection.filter(item => {
                return item[field] == value;
            }, value);
            return check.length > 0;
        },
        collectionCheckArraysFirstValueMatchesField(collection, array, field) {
            if (array.length !== 0) {
                const collectionCheckValueMatchesField = this.collectionCheckValueMatchesField(collection, array[0], field);
                if (collectionCheckValueMatchesField) {
                    return true;
                }
            }
            return false;
        },
        getNumberFromRouteQuery(route, key) {
            let result = null;
            if (route?.query && route.query[key] !== undefined && !isNaN(route.query[key])) {
                result = +route.query[key];
            }
            return result;
        },
        getHumanReadableDate(theMoment) {
            let value = null;
            const updateMoment = moment(new Date(theMoment));
            const currMoment = moment();
            const diff = moment.duration(updateMoment.diff(currMoment));
            if (diff.asWeeks() > -1) {
                value = updateMoment.fromNow();
            } else {
                value = updateMoment.format("llll");
            }
            value = value.charAt(0).toUpperCase() + value.slice(1);
            return value;
        },
        getHumanReadableDateVersion2(theMoment) {
            const updateMoment = moment(new Date(theMoment));
            const currMoment = moment();

            if (updateMoment.isSame(currMoment, 'day')) {
                return updateMoment.format("hh:mm A");
            } else if (updateMoment.isSame(currMoment, 'week')) {
                return updateMoment.format("ddd, hh:mm A");
            } else {
                return updateMoment.format("ddd, MMM D, YYYY hh:mm A");
            }
        }


    },
};
